// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const EDIT_TESTING_FINISHED_POST = "Uprav fin\u00e1lny text testovania";
export const SEO_DESCRIPTION_COUNSELLINGS = "Diskusn\u00e9 miesto pre mami\u010dky pln\u00e9 sk\u00fasenosti, r\u00e1d, tipov a trikov priamo z prvej ruky. Miesto ka\u017edodenn\u00fdch radost\u00ed a starost\u00ed, ktor\u00e9 nie je o ide\u00e1lnych mami\u010dk\u00e1ch, ale o skuto\u010dnom \u017eivote.";
export const SEO_TITLE_TESTINGS = "Testovania";
